import React from "react"
import parse from 'html-react-parser';

import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';

const BlockFAQ = ({ faqs }) => {

    var mainEntity = []

    {faqs && faqs.map && faqs.map((faq, i) => {
        if(faq.question) {
           var question = faq.question
           var answer = faq.answer
        } else {
           var question = faq.fensterFaqQuestion
           var answer = faq.fensterFaqAnswer
        }
        mainEntity.push({
            '@type': "Question",
            'name': question.replace(/<\/?[^>]+(>|$)/g, ""),
            'acceptedAnswer': { '@type': "Answer", 'text': answer.replace(/<\/?[^>]+(>|$)/g, "") }
        })
    })}

    var faqStructuredData = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        'mainEntity': mainEntity
    }

    return (
        <div className="px-4">
            <Accordion allowZeroExpanded="true" allowMultipleExpanded="true">
                {faqs && faqs.map && faqs.map((faq, i) => {

                   if(faq.question) {
                      var question = faq.question
                      var answer = faq.answer
                   } else {
                      var question = faq.fensterFaqQuestion
                      var answer = faq.fensterFaqAnswer
                   }

                   return (
                       <AccordionItem
                           key={i}
                           className={i === 0 ? 'border-t border-b border-rekord-formgray' : 'border-b border-rekord-formgray'}
                       >
                           <AccordionItemHeading>
                               <AccordionItemButton className="relative py-4 accordion-toggler">
                                   <h3 className="text-black text-lg lg:text-2xl font-light mr-16">{parse(question)}</h3>
                               </AccordionItemButton>
                           </AccordionItemHeading>
                           <AccordionItemPanel className="py-4 text-lg font-light">
                               <div className="max-w-7xl py-1">{parse(answer)}</div>
                           </AccordionItemPanel>
                       </AccordionItem>

                    )

                })}
            </Accordion>
            <script
               type="application/ld+json"
               dangerouslySetInnerHTML={{ __html: JSON.stringify(faqStructuredData) }}
            />
        </div>
    )

}

export default BlockFAQ
